import { Box, Divider, List, ListItemButton, ListItemIcon, ListSubheader, Paper, styled, } from '@mui/material';
// The portal's v2 theme restyles these slots under this name (design-theme's
// SLASH_COMMAND_MENU_THEME_NAME); this package must not depend on design-theme.
const SLASH_COMMAND_MENU_THEME_NAME = 'OvSlashCommandMenu';
const MENU_WIDTH = '14.375rem';
const MENU_MAX_HEIGHT = '20rem';
export const MenuPaper = styled(Paper, {
    name: SLASH_COMMAND_MENU_THEME_NAME,
    slot: 'Paper',
})(({ theme }) => ({
    minWidth: MENU_WIDTH,
    maxWidth: MENU_WIDTH,
    maxHeight: MENU_MAX_HEIGHT,
    overflowY: 'auto',
    borderRadius: theme.spacing(1.5),
    overflow: 'hidden',
}));
export const MenuList = styled(List, {
    name: SLASH_COMMAND_MENU_THEME_NAME,
    slot: 'List',
})(({ theme }) => ({
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    overflowY: 'auto',
    maxHeight: MENU_MAX_HEIGHT,
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
}));
export const MenuListSubheader = styled(ListSubheader, {
    name: SLASH_COMMAND_MENU_THEME_NAME,
    slot: 'Subheader',
})(({ theme }) => ({
    ...theme.typography.overline,
    lineHeight: 2.5,
    color: theme.palette.text.secondary,
    backgroundColor: 'transparent',
    paddingTop: theme.spacing(0.25),
}));
export const MenuListItemButton = styled(ListItemButton, {
    name: SLASH_COMMAND_MENU_THEME_NAME,
    slot: 'Item',
})(({ theme }) => ({
    alignItems: 'center',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    gap: theme.spacing(0.75),
    '& .MuiListItemText-primary, & .MuiListItemText-secondary': {
        fontSize: theme.typography.overline.fontSize,
    },
    '& .MuiListItemText-secondary': {
        lineHeight: 1,
    },
}));
export const MenuListItemIcon = styled(ListItemIcon, {
    name: SLASH_COMMAND_MENU_THEME_NAME,
    slot: 'ItemIcon',
    shouldForwardProp: (prop) => prop !== 'isSelected',
})(({ isSelected, theme }) => ({
    minWidth: 0,
    marginRight: theme.spacing(0.25),
    display: 'flex',
    alignItems: 'stretch',
    color: isSelected ? theme.palette.primary.main : theme.palette.text.secondary,
}));
export const IconContainer = styled(Box, {
    name: SLASH_COMMAND_MENU_THEME_NAME,
    slot: 'IconBox',
})(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.action.hover,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    minWidth: theme.spacing(3.5),
    minHeight: theme.spacing(3.5),
    color: 'inherit',
    '& svg': {
        fontSize: theme.typography.overline.fontSize,
    },
}));
export const PrefixLabelBox = styled(Box, {
    name: SLASH_COMMAND_MENU_THEME_NAME,
    slot: 'PrefixLabel',
})(({ theme }) => ({
    fontSize: theme.typography.overline.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    letterSpacing: '0.05em',
    color: 'inherit',
}));
export const MenuStatus = styled(Box, {
    name: SLASH_COMMAND_MENU_THEME_NAME,
    slot: 'Status',
})(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1.5, 2),
}));
export const MenuDivider = styled(Divider, {
    name: SLASH_COMMAND_MENU_THEME_NAME,
    slot: 'Divider',
})(({ theme }) => ({
    opacity: 0.4,
    marginTop: theme.spacing(1),
    marginBottom: 0,
}));
